import {Injectable} from '@angular/core';
import {SettingService} from './setting-service';
import { User } from '../model/user';
import { Device } from '../model/device';
import { plainToClass } from 'class-transformer';
import { Config } from '../../../config/config';



@Injectable()
export class ApiEndpoints {

  constructor(private settingService: SettingService) {}

  get BASE_API_URL(): string {
    // return 'http://192.168.0.100:8000/';
    // return  'http://127.0.0.1:8000/';
    // return  'http://127.0.0.1:8000/app_dev.php/';
    // return  'https://app.bessalel.net/';
    return Config.urlserveuravecslash;
  }

  /************************* LOGIN ********************************/
  get GET_URL_LOGIN(): string {
    if(this.getDevice !== undefined)
    return this.BASE_API_URL + 'api/login?device=' + this.getDevice.id;
    else
    return this.BASE_API_URL + 'api/login';
  }

  /************************* LOGIN ********************************/

  /************************* PRODUIT ********************************/
  get URL_GET_PRODUITS(): string {
    return this.BASE_API_URL + 'api/produits';
  }

  URL_GET_ETAT(from: string, to: string): string {
    return this.BASE_API_URL + 'api/produits/stock/etat?from=' + from + '&to=' + to;
  }

  URL_GET_COMMANDES_PRODUITS(type: string, idpartenaire: any): string {
    return this.BASE_API_URL + 'api/produits/commandes/inventaire?type=' + type + '&from=' + this.settingService.fromEtatCommande + '&to=' + this.settingService.toEtatCommande + '&partenaireid=' + idpartenaire;
  }

  URL_PRODUIT_ADD_IMAGE(idprod: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/addimage'
  }

  URL_PRODUIT_REMOVE_IMAGE(idprod: number, image: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/removeimage?image=' + image;
  }

  URL_PRODUIT_ADD_FICHIER(idprod: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/addfichier'
  }

  URL_PRODUIT_REMOVE_FICHIER(idprod: number, fichier: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/removefichier?fichier=' + fichier;
  }


  URL_GET_RECONCILIATION_PRODUITS(type): string {
    return this.BASE_API_URL + 'api/produits/commandes/reconciliation?type=' + type + '&from=' + this.settingService.fromEtatCommande + '&to=' + this.settingService.toEtatCommande;
  }

  get GET_URL_POST_PRODUIT(): string {
    return this.BASE_API_URL + 'api/produits';
  }

  GET_URL_PUT_PRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/produits/' + id;
  }

  GET_URL_DELETE_PRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/produits/' + id;
  }
  /************************* PRODUIT ********************************/


  /************************* CATPRODUIT ********************************/
  get URL_GET_CATPRODUITS(): string {
    return this.BASE_API_URL + 'api/catproduits';
  }

  get GET_URL_POST_CATPRODUIT(): string {
    return this.BASE_API_URL + 'api/catproduits';
  }

  GET_URL_PUT_CATPRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/catproduits/' + id;
  }

  GET_URL_DELETE_CATPRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/catproduits/' + id;
  }
  /************************* CATPRODUIT ********************************/



  /************************* CATEGORY ********************************/
  URL_GET_CATEGORY(type: string): string {
    return this.BASE_API_URL + 'api/categories?type=' + type;
  }

  URL_GET_CATEGORYBYID(id: number): string {
    return this.BASE_API_URL + 'api/categories/' + id;
  }

  GET_URL_DELETE_CATEGORY(id: number): string {
    return this.BASE_API_URL + 'api/categories/' + id;
  }

  get GET_URL_POST_CATEGORY(): string {
    return this.BASE_API_URL + 'api/categories';
  }

  GET_URL_PUT_CATEGORY(id: number): string {
    return this.BASE_API_URL + 'api/categories/' + id;
  }
  /************************* CATEGORY ********************************/



  /************************* ARTICLE ********************************/
  get URL_GET_ARTICLE(): string {
    return this.BASE_API_URL + 'api/articles';
  }

  URL_GET_ARTICLEBYID(id: number): string {
    return this.BASE_API_URL + 'api/articles/' + id;
  }

  GET_URL_DELETE_ARTICLE(id: number): string {
    return this.BASE_API_URL + 'api/articles/' + id;
  }

  get GET_URL_POST_ARTICLE(): string {
    return this.BASE_API_URL + 'api/articles';
  }

  GET_URL_PUT_ARTICLE(id: number): string {
    return this.BASE_API_URL + 'api/articles/' + id;
  }
  /************************* ARTICLE ********************************/



  /************************* MENU ********************************/

  get URL_GET_MENU(): string {
    return this.BASE_API_URL + 'api/menus';
  }

  URL_GET_MENUBYID(id: number): string {
    return this.BASE_API_URL + 'api/menus/' + id;
  }

  GET_URL_DELETE_MENU(id: number): string {
    return this.BASE_API_URL + 'api/menus/' + id;
  }

  get GET_URL_POST_MENU(): string {
    return this.BASE_API_URL + 'api/menus';
  }

  GET_URL_PUT_MENU(id: number): string {
    return this.BASE_API_URL + 'api/menus/' + id;
  }

  /************************* MENU ********************************/



  /************************* PUBLICATION ********************************/
  
  GET_URL_ACTIVATE_PUBLICATION(idpub: number, publish: boolean): string {
    
    let ispublish = 0;
    if(publish)
    ispublish = 1;

    return this.BASE_API_URL + 'api/publication/'+ idpub + '/setpublish?ispublish=' + ispublish;
  }

  /************************* PUBLICATION ********************************/



  /************************* DEVICE ********************************/
  get URL_GET_DEVICE(): string {
    return this.BASE_API_URL + 'api/devices';
  }

  GET_URL_DELETE_DEVICE(id: number): string {
    return this.BASE_API_URL + 'api/devices/' + id;
  }

  GET_URL_PATCH_DEVICE(id: number): string {
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/devices/' + id + '?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/devices/' + id;
  }

  GET_URL_PATCH_DEVICE_ADMIN(id: number): string {
    return this.BASE_API_URL + 'api/devices/' + id;
  }

  
  GET_URL_POST_DEVICE(): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/devices?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/devices';
    
  }

  /************************* DEVICE ********************************/







  /************************* PAIEMENT ********************************/
  get URL_GET_PAIEMENT(): string {
    return this.BASE_API_URL + 'api/paiements';
  }

  GET_URL_DELETE_PAIEMENT(id: number): string {
    return this.BASE_API_URL + 'api/paiements/' + id;
  }


  GET_URL_PATCH_PAIEMENT_ADMIN(id: number): string {
    return this.BASE_API_URL + 'api/paiement/' + id;
  }

  
  GET_URL_POST_PAIEMENT(): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/paiements?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/paiements';
    
  }

  URL_GET_VALIDATEPAIEMENT(id: number): string {
    return this.BASE_API_URL + 'api/validategetgain/' + id;
  }
  

  /************************* PAIEMENT ********************************/








  /************************* COMMENT ********************************/

  get URL_GET_COMMENT(): string {
    return this.BASE_API_URL + 'api/comment';
  }

  GET_URL_DELETE_COMMENT(id: number): string {
    return this.BASE_API_URL + 'api/comment/' + id;
  }

  GET_URL_PATCH_COMMENT(id: number): string {
    return this.BASE_API_URL + 'api/comment/' + id;
  }

  /* GET_URL_POST_COMMENT(): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/devices?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/devices';
    
  } */

  /************************* COMMENT ********************************/


  /************************* AVIS PRODUIT ********************************/

  get URL_GET_AVISPRODUIT(): string {
    return this.BASE_API_URL + 'api/avisproduit';
  }

  GET_URL_DELETE_AVISPRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/avisproduit/' + id;
  }

  GET_URL_PATCH_AVISPRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/avisproduit/' + id;
  }

  /* GET_URL_POST_COMMENT(): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/devices?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/devices';
    
  } */

  /************************* AVIS PRODUIT ********************************/



  /************************* TAXE ********************************/
  get URL_GET_TAXE(): string {
    return this.BASE_API_URL + 'api/taxes';
  }

  get GET_URL_POST_TAXE(): string {
    return this.BASE_API_URL + 'api/taxes';
  }

  GET_URL_PUT_TAXE(id: number): string {
    return this.BASE_API_URL + 'api/taxes/' + id;
  }

  GET_URL_DELETE_TAXE(id: number): string {
    return this.BASE_API_URL + 'api/taxes/' + id;
  }
  /************************* TAXE ********************************/





  /************************* PLAN TARIFAIRE ********************************/
  URL_GET_PLANTARIFAIRE(): string {
    return this.BASE_API_URL + 'api/plantarifaires';
  }

  GET_URL_DELETE_PLANTARIFAIRE(id: number): string {
    return this.BASE_API_URL + 'api/plantarifaires/' + id;
  }

  get GET_URL_POST_PLANTARIFAIRE(): string {
    return this.BASE_API_URL + 'api/plantarifaires';
  }

  GET_URL_PUT_PLANTARIFAIRE(id: number): string {
    return this.BASE_API_URL + 'api/plantarifaires/' + id;
  }

  /************************* PLAN TARIFAIRE ********************************/




  /************************* INVENTAIRE ********************************/

  URL_GET_INVENTAIRE(from: string, to: string): string {
    return this.BASE_API_URL + 'api/inventairestock?from=' + this.settingService.fromInventory + '&to=' + this.settingService.toInventory;
  }

  GET_URL_DELETE_INVENTAIRE(id: number): string {
    return this.BASE_API_URL + 'api/inventairestock/' + id;
  }

  get GET_URL_POST_INVENTAIRE(): string {
    return this.BASE_API_URL + 'api/inventairestock';
  }

  GET_URL_PUT_INVENTAIRE(id: number): string {
    return this.BASE_API_URL + 'api/inventairestock/' + id;
  }

  /************************* INVENTAIRE ********************************/




  /************************* PERMISSIONS ********************************/
  URL_GET_PERMISSIONS(): string {
    return this.BASE_API_URL + 'api/permissions';
  }

  /************************* PERMISSIONS ********************************/


  /************************* USER ********************************/
  
  URL_GET_USER(iduser): string {
    return this.BASE_API_URL + 'api/users/' + iduser;
  }
  
  URL_GET_USERS(): string {
    return this.BASE_API_URL + 'api/users';
  }

  GET_URL_DELETE_USERS(id: number): string {
    return this.BASE_API_URL + 'api/users/' + id;
  }

  get GET_URL_POST_USERS(): string {
    return this.BASE_API_URL + 'api/users';
  }

  GET_URL_PATCH_USERS(id: number): string {
    return this.BASE_API_URL + 'api/users/' + id;
  }

  GET_URL_UPDATE_SOLDE_USER(partnerId, newsolde): string {

    return this.BASE_API_URL + 'api/updatesolde/users/' + partnerId + '?newsolde=' + newsolde;

  }


  /************************* USER ********************************/


  /************************* COMPANY ********************************/

  get GET_URL_POST_COMPANY(): string {
    return this.BASE_API_URL + 'api/company';
  }

  GET_URL_PATCH_COMPANY(id: number): string {
    return this.BASE_API_URL + 'api/company/' + id;
  }

  GET_URL_COMPANY_UPDATE_LOGO(id: number): string {
    return this.BASE_API_URL + 'api/company/logo/' + id;
  }

  /************************* COMPANY ********************************/


  /************************* PARTENAIRE ********************************/
  URL_GET_PARTNER(type: string): string {
    return this.BASE_API_URL + 'api/partenaires?type=' + type;
  }

  URL_GET_ALL_PARTNER(): string {
    return this.BASE_API_URL + 'api/partenaires';
  }

  URL_GET_PARTNERINVENTAIRE(type: string): string {

    let to = '';
    if (this.settingService.toCreancePartenaire !== '')
    to = '&to=' + this.settingService.toCreancePartenaire  + ' 23:59';
    else
    to = '&to=';

    let from = '';
    if (this.settingService.fromCreancePartenaire !== '')
    from = '&from=' + this.settingService.fromCreancePartenaire +  ' 00:00';
    else
    from = '&from=';

    return this.BASE_API_URL + 'api/inventaire/facture?type=' + type + from + to ;

  }


  get GET_URL_POST_PARTNER(): string {
    return this.BASE_API_URL + 'api/partenaires';
  }

  get  URL_GET_DASHBOARD(): string {
    return this.BASE_API_URL + 'api/dashboard';
  }

  get  URL_GET_SETTING(): string {
    return this.BASE_API_URL + 'frontend/api/settings';
  }

  get  GET_URL_PATCH_SETTINGS(): string {
    return this.BASE_API_URL + 'api/settings';
  }
  

  GET_URL_PUT_PARTNER(id: number): string {
    return this.BASE_API_URL + 'api/partenaires/' + id;
  }

  GET_URL_DELETE_PARTNER(id: number): string {
    return this.BASE_API_URL + 'api/partenaires/' + id;
  }
  /************************* PARTENAIRE ********************************/



  /************************* FACTURE ********************************/
  URL_GET_FACTURES( dateto: string, datefrom: string, type: string, idpartner: string, paidstatus: string, state: string, livraison: string): string {
    let to = '';
    if (dateto !== '')
    to = '&to=' + dateto  + ' 23:59';
    else
    to = '&to=';

    let from = '';
    if (datefrom !== '')
    from = '&from=' + datefrom +  ' 00:00';
    else
    from = '&from=';

    return this.BASE_API_URL + 'api/factures?type=' + type + from + to  + '&partner=' + idpartner + '&paidstatus=' + paidstatus + '&etat=' + state + '&livraison=' + livraison;
  }

  URL_GET_FACTURE(idfacture: number): string {
    return this.BASE_API_URL + 'api/facture/' + idfacture ;
  }

  get GET_URL_POST_FACTURE(): string {
    return this.BASE_API_URL + 'api/factures';
  }

  GET_URL_PUT_FACTURE(id: number): string {
    return this.BASE_API_URL + 'api/factures/' + id;
  }

  GET_URL_DELETE_FACTURE(id: number): string {
    return this.BASE_API_URL + 'api/factures/' + id;
  }

  GET_URL_POST_FACTUREANDFLUX(idcompte: number): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if (idcompte === undefined)
    return this.BASE_API_URL + 'api/facturesflux';
    else
    return this.BASE_API_URL + 'api/facturesflux?tresorerie=' + idcompte.toString();
  }

  GET_URL_PATCH_FACTUREANDFLUX(id: number, idcompte: number): string {

    if (idcompte === undefined)
    return this.BASE_API_URL + 'api/facturesflux/' + id;
    else
    return this.BASE_API_URL + 'api/facturesflux/' + id + '?tresorerie=' + idcompte.toString();

  }

  /************************* FACTURE ********************************/




  /************************* BORDEREAU ********************************/
  URL_GET_BORDEREAUX( dateto: string, datefrom: string, type: string, state: string): string {
    let to = '';
    if (dateto !== '')
    to = '&to=' + dateto  + ' 23:59';
    else
    to = '&to=';

    let from = '';
    if (datefrom !== '')
    from = '&from=' + datefrom +  ' 00:00';
    else
    from = '&from=';

    return this.BASE_API_URL + 'api/bordereau?type=' + type + from + to  + '&etat=' + state;
  }

  URL_GET_BORDEREAU(idbordereau: number): string {
    return this.BASE_API_URL + 'api/bordereau/' + idbordereau ;
  }

  get GET_URL_POST_BORDEREAU(): string {
    return this.BASE_API_URL + 'api/bordereau';
  }

  GET_URL_PUT_BODEREAU(id: number): string {
    return this.BASE_API_URL + 'api/bodereau/' + id;
  }

  GET_URL_DELETE_BORDEREAU(id: number): string {
    return this.BASE_API_URL + 'api/bordereau/' + id;
  }

  get GET_URL_POST_BORDEREAUANDFLUX(): string {
    return this.BASE_API_URL + 'api/bordereauflux';
  }

  GET_URL_PATCH_BORDEREAUANDFLUX(id: number): string {
    return this.BASE_API_URL + 'api/bordereauflux/' + id;
  }

  /************************* BORDEREAU ********************************/





  /************************* FLUXSTOCK ********************************/

  get GET_URL_POST_FLUXSTOCK(): string {
    return this.BASE_API_URL + 'api/fluxstock';
  }
  URL_GET_FLUXSTOCKPROD(idproduit: number): string {
    return this.BASE_API_URL + 'api/etatfluxstock/' + idproduit + '?from=' + this.settingService.fromEtat + '&to=' + this.settingService.toEtat;
  }
  GET_URL_PUT_FLUXSTOCK(id: number): string {
    return this.BASE_API_URL + 'api/fluxstock/' + id;
  }

  GET_URL_DELETE_FLUXSTOCK(id: number): string {
    return this.BASE_API_URL + 'api/fluxstock/' + id;
  }

  /************************* FLUXSTOCK ********************************/


  /************************* REGLEMENT ********************************/

  get GET_URL_POST_REGLEMENT(): string {
    return this.BASE_API_URL + 'api/reglements';
  }

  GET_URL_PUT_REGLEMENT(id: number): string {
    return this.BASE_API_URL + 'api/reglements/' + id;
  }

  GET_URL_DELETE_REGLEMENT(id: number): string {
    return this.BASE_API_URL + 'api/reglements/' + id;
  }

  /************************* FLUXSTOCK ********************************/



  /************************* FLUX ********************************/


  URL_GET_CAISSE(patner?,  nature?): string {
    let result = this.BASE_API_URL + 'api/caisse/flux?from=' + this.settingService.fromCaisse + '&to=' + this.settingService.toCaisse;;
    
    if(patner !== undefined)
    result += '&patner=' + patner.toString();
  
    if(nature !== undefined)
    result += '&nature=' + nature.toString();

    return result;

  }

  GET_URL_POST_FLUX(idcompteTransfert: number, idsourceCredit: number, idsourceVersement: number): string {

    let param = '';

    if (idcompteTransfert !== undefined) {

      if (param !== '')
      param += 'transfertTo=' + idcompteTransfert.toString();
      else
      param += '?transfertTo=' + idcompteTransfert.toString();

    }

    if (idsourceCredit !== undefined) {
      if (param !== '')
      param += '&sourceCredit=' + idsourceCredit.toString();
      else
      param += '?sourceCredit=' + idsourceCredit.toString();
    }

    if (idsourceVersement !== undefined) {
      if (param !== '')
      param += '&sourceVersement=' + idsourceVersement.toString();
      else
      param += '?sourceVersement=' + idsourceVersement.toString();
    }

    return this.BASE_API_URL + 'api/flux' + param;

  }

  GET_URL_PATCH_FLUX(id: number): string {
    return this.BASE_API_URL + 'api/flux/' + id;
  }

  GET_URL_DELETE_FLUX(id: number): string {
    return this.BASE_API_URL + 'api/flux/' + id;
  }


  URL_GET_CASHSESSIONS(dateto: string, datefrom: string, user: string, state: string, nature: string): string {

    let to = '';
    if (dateto !== '')
    to = '&to=' + dateto  + ' 23:59';
    else
    to = '&to=';

    let from = '';
    if (datefrom !== '')
    from = '&from=' + datefrom +  ' 00:00';
    else
    from = '&from=';

    return this.BASE_API_URL + 'api/cashstates?type=' + from + to + '&state=' + state + '&user=' + user + '&nature=' + nature;

  }


  URL_ACCOUNTPARTNER_CASH(typePartner: string): string {
    return this.BASE_API_URL + 'api/partner/caisse/account?typepartner=' + typePartner;
  }

  URL_GET_CASHSESSION(id: number): string {
    return this.BASE_API_URL + 'api/cashstates/' + id;
  }

  URL_CLOSE_CASHSESSION(id: number): string {
    return this.BASE_API_URL + 'api/cashstates/' + id + '/close';
  }

  GET_URL_DELETE_CASHSESSION(id: number): string {
    return this.BASE_API_URL + 'api/cashstates/' + id;
  }

  get GET_URL_POST_CASHSESSION(): string {
    return this.BASE_API_URL + 'api/cashstates';
  }

  GET_URL_PATCH_CASHSESSION(id: number): string {
    return this.BASE_API_URL + 'api/cashstates/' + id;
  }

 

  /************************* FLUX ********************************/


  /************************* PRODUIT ********************************/
  get URL_GET_COMPTES(): string {
    return this.BASE_API_URL + 'api/comptes';
  }

  URL_GET_COMPTE(id: number): string {
    return this.BASE_API_URL + 'api/comptes/' + id;
  }

  get GET_URL_POST_COMPTES(): string {
    return this.BASE_API_URL + 'api/comptes';
  }

  GET_URL_PUT_COMPTES(id: number): string {
    return this.BASE_API_URL + 'api/comptes/' + id;
  }

  GET_URL_DELETE_COMPTES(id: number): string {
    return this.BASE_API_URL + 'api/comptes/' + id;
  }

  /************************* PRODUIT ********************************/


  get getDevice(): Device {

      const device = JSON.parse(localStorage.getItem('device')) || undefined;

      if( device !== undefined)
      return plainToClass(Device, device as object);
      else
      return undefined;

  }
  
  get getUser(): User {

    const token = JSON.parse(localStorage.getItem('bessalel_token')) || undefined;

    if( token !== undefined && token !== null)
    return token.user.id;
    else
    return undefined;

  }

  /* get URL_GET_LEVEL(): string {
    return this.BASE_API_URL + "levels";
  }

  get URL_GET_SCHOOL(): string {
    return this.BASE_API_URL + "schools?include=faculties";
  }

  get URL_GET_COUNTRIES(): string {
    return this.BASE_API_URL + "countries";
  }

  get URL_GET_SPECIALITE(): string {
    return this.BASE_API_URL + "specialities";
  }

  GET_URL_GET_FACULTY_SPECIALITE(facultyId:number): string {
    return this.BASE_API_URL + "specialities?search=faculty_id:"+facultyId;
  }

  get URL_REGISTER_USER_STUDENT(): string {

    return this.BASE_API_URL + "public/pupils";
  }

  get URL_REGISTER_TEAHER(): string {

    return this.BASE_API_URL + "teachers";
  }


  GET_URL_GET_FEEDS(userId: number, page: number): string {

    return this.BASE_API_URL + "users/" + userId + "/difficulties?include=comments,creator&page=" + page;

  }

  GET_URL_REGISTER_USER_STUDENT_WITH_SCHOOL_CODE(code: string): string {

    return this.BASE_API_URL + "register/students/" + code;
  }

  GET_URL_LOGIN_USER(): string {

    return this.BASE_API_URL + "clients/web/admin/login"
  }

  GET_URL_USER_WITH_TOKEN(): string {

    return this.BASE_API_URL + "user/profile"
  }


  constructor() {
  }

  GET_URL_FOLLOW_TOOT(id: any) {

    return this.BASE_API_URL + "difficulties/" + id + "/followers"
  }

  GET_URL_COMMENT_TOOT(difficulty_id: any) {
    return this.BASE_API_URL + "difficulties/" + difficulty_id + "/comments"
  }

  GET_URL_USER_CLASSROOM(userId: any) {

    return this.BASE_API_URL + "users/" + userId + "/classrooms/current"
  }

  GET_URL_COURSES_CLASSROOM(classroomId: any) {

    return this.BASE_API_URL + "courses?search=classroom_id:" + classroomId + "&include=teacher,subject"
  }

  GET_URL_USER_FRIENDS(userId: any) {

    return this.BASE_API_URL + "users/" + userId + "/friends"
  }

  GET_URL_USER_SHOOL(userId: any) {
    return this.BASE_API_URL + "users/" + userId + "/schools/current"
  }

  GET_URL_POST_DIFFICULTY() {
    return this.BASE_API_URL + "difficulties"
  }

  GET_URL_COMMENT_A_COMMENT(comment_id: any) {

    return this.BASE_API_URL + "comments/" + comment_id + "/reply";
  }

  GET_URL_LIKE_COMMENT(comment_id: any) {

    return this.BASE_API_URL + "comments/" + comment_id + "/like";
  }

  GET_URL_UNLIKE_COMMENT(comment_id: any) {

    return this.BASE_API_URL + "comments/" + comment_id + "/unlike";
  }

  GET_URL_UNDERSTAND_TOOT(structure_id: any) {

    return this.BASE_API_URL + "structures/" + structure_id + "/comprehensions";
  }

  GET_URL_REGISTER_USER_DEVICE_TOKEN(userId: any) {

    return this.BASE_API_URL + "users/" + userId;
  }

  GET_URL_DELETE_FEED(feedId: any) {

    return this.BASE_API_URL + "difficulties/" + feedId;
  }
  GET_URL_UPDATE_FEED(feedId: any) {

    return this.BASE_API_URL + "difficulties/" + feedId;
  }

  GET_URL_SET_FEED_SOLVED(feedId: any) {

    return this.BASE_API_URL + "difficulties/" + feedId;
  }

  GET_URL_UPDATE_USER_PICTURE(userId: any) {

    return this.BASE_API_URL + "users/" + userId + "/picture";

  }

  GET_URL_USER_PROFILE(userId: any) {

    return this.BASE_API_URL + "users/" + userId + "/full-profile";
  }

  GET_URL_DELETE_COMMENT(commentId: any) {
    return this.BASE_API_URL + "comments/" + commentId;
  }

  GET_URL_UPDATE_COMMENT(commentId: any) {

    return this.BASE_API_URL + "comments/" + commentId;
  }

  GET_URL_GET_NOTIFICATION(userId: any) {

    return this.BASE_API_URL + "notifications/users/" + userId;
  } */


}
